(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ucp-pdp-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ucp-product-description')) {
 customElements.define('ucp-product-description', class extends HTMLElement {
  connectedCallback() {
   this.text = this.querySelector('.ucp-product-description__text');
   this.button = this.querySelector('button');
   if (!this.text || !this.button) return;
   this.dataset.expanded = 'false';
   this.button.setAttribute('aria-expanded', 'false');
   this.button.querySelector('[data-view-more]').hidden = false;
   this.button.querySelector('[data-view-less]').hidden = true;
   this.toggle = () => {
    const expanded = this.dataset.expanded !== 'true';
    this.dataset.expanded = String(expanded);
    this.button.setAttribute('aria-expanded', String(expanded));
    this.button.querySelector('[data-view-more]').hidden = expanded;
    this.button.querySelector('[data-view-less]').hidden = !expanded;
   };
   this.button.addEventListener('click', this.toggle);
   this.observer = new ResizeObserver(() => {
    const lineHeight = parseFloat(getComputedStyle(this.text).lineHeight);
    this.button.hidden = this.text.scrollHeight <= lineHeight * 2 + 1;
   });
   this.observer.observe(this.text);
  }
  disconnectedCallback() {
   this.observer?.disconnect();
   this.button?.removeEventListener('click', this.toggle);
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
